import { Decimal } from '@snap-types/types/decimal';
import { Nullish } from '@snap-types/types/nullish';

export function decimalToPercent(
  decimal: Nullish<Decimal>,
  precision: number = 2,
): string {
  if (!decimal) {
    return '-';
  }

  return `${decimal.times(100).toFixed(precision)}%`;
}

export function decimalToCurrency(
  decimal: Nullish<Decimal>,
  precision: number = 2,
): string {
  if (!decimal) {
    return '-';
  }

  return `$${decimal.toFixed(precision)}`;
}

/**
 * Converts a number of decimal places to a step value for use in input fields.
 */
export function decimalToStep(decimalPlaces: string | number) {
  return 1 / Math.pow(10, Number(decimalPlaces === '' ? 2 : decimalPlaces));
}
